import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bc727f52"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "wc-lg"
}
const _hoisted_2 = {
  key: 0,
  class: "wc-lg anek light"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "2", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "2", -1))
const _hoisted_5 = {
  key: 1,
  class: "wc-lg anek light"
}
const _hoisted_6 = {
  key: 1,
  class: "wc-lg anek light"
}
const _hoisted_7 = {
  key: 2,
  class: "wc-lg anek light"
}
const _hoisted_8 = {
  key: 3,
  class: "wc-lg anek light"
}
const _hoisted_9 = {
  key: 4,
  class: "wc-lg anek light"
}
const _hoisted_10 = {
  key: 3,
  class: "icon"
}
const _hoisted_11 = {
  key: 4,
  class: "icon"
}
const _hoisted_12 = {
  key: 6,
  class: "icon"
}
const _hoisted_13 = { class: "show-cont" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "2", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "2", -1))
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]

import { computed, Ref } from "vue";
import { ref, watch, onMounted } from "vue";
import get from "lodash-es/get";

import { useGlobalStore } from "@/store/pinia/global";
import { useApartmentStore } from "@/store/pinia/apartments";
import fn from "@/helpers/func";
import Switcher from "@/components/UI/Buttons/Switcher.vue";
import arrowDown from "@/components/UI/SVG/ArrowDown.vue";
import CloseLogo from "../SVG/CloseLogo.vue";
import { formatMoney } from "@/composables/moneyFormat";
import { handleResize } from '@/composables/resizeHandler';

// DEFINE STORE

export default /*#__PURE__*/_defineComponent({
  props: {
    data: {
        required: true,
        type: Object || Number,
    },
    blockFilter: {
        required: false,
        type: Boolean,
    },
    floorFilter: {
        required: false,
        type: Boolean,
    },
    showCurrencyToggler: {
        required: false,
        type: Boolean,
    },
    selectTitle: {
        required: false,
        type: String,
    },
    clearVal: {
        required: false,
        type: Boolean,
    },
    forNumber: {
        required: false,
        type: Boolean,
    },
    htmlFormat: {
        required: false,
        type: Boolean,
    },
    areaFormat: {
        required: false,
        type: Boolean,
    },
    priceFormat: {
        required: false,
        type: Boolean,
    },
    noClear: {
        required: false,
        type: Boolean,
    },
    isSymbol: {
        required: false,
        type: String,
    },
    autoSelectData: {
        default: null,
        required: false,
    },
    layout2: {
        required: false,
        type: Boolean
    },
    onlyPrice: {
        required: false,
        type: Boolean
    },
    onlyCalc: {
        required: false,
        tyoe: Boolean
    },
    blockFormat: {
        required: false,
        type: Boolean
    },
    roomFormat: {
        required: false,
        type: Boolean
    }


},
  emits: ["getData"],
  setup(__props, { emit }) {

const props = __props

/**
 * @author Tornike Jortmenadze (Jortsoft), Irakli Kandelaki
 */

// IMPORTS
const store = useGlobalStore();
const apStore = useApartmentStore();

const { windowWidth } = handleResize();


// PROPS




// DEFINE EMITS


// DEFINE GLOBAL VARIABLES
const selectOpen: Ref<boolean> = ref(false);
const currentValue: Ref<number> = ref(null);
const currentValueTitle: Ref<string | string[]> = ref(null);
const iconShow: Ref<boolean> = ref(true);
const arrowBonus = ref(false)

// REACTIVE DATA
const getCurrency = computed(() => get(store, "currency"));

const filteredData = computed(() => {
    let data = props.data

    if (apStore.availableBlockIds?.length && props.blockFilter) {
        const avBlockIds = Array.from(apStore.availableBlockIds)
        data = props.data.filter((item: any) => avBlockIds.includes(item.id));


    } else if (apStore.availableFloorNumbers?.length && props.floorFilter) {
        const avFloorNumbers: number[] = Array.from(apStore.availableFloorNumbers);

        data = props.data.filter((item: any) => avFloorNumbers.includes(item));
        if (!apStore.filteredData.selectedFloor) {
            data = avFloorNumbers.sort((a, b) => a - b);

        }
    } else if (apStore.availableArea && props.areaFormat) {

        data = props.data.filter((area: any) => {
            const containsArea = apStore.availableArea.some((avArea: any) => avArea < Number(area.title) || avArea > Number(area.title2) ? false : true
            );
            return containsArea;
        })
    } else if (apStore.availablePrice && props.showCurrencyToggler) {

        data = props.data.filter((price: any) => {
            const containsArea = apStore.availablePrice.some((avArea: any) => avArea < Number(price.title) || avArea > Number(price.title2) ? false : true
            );
            return containsArea;
        })
    }
    for (let i = 0; i < data?.length; i++) {
        if (data[i] === apStore.filteredData.roomCount) {
            data[i] = `${data[i]}+`
        }
    }
    if (props.roomFormat) {
        return data.sort()
    }
    return data;

})


// CUSTOM FUNCTIONS
const openSelect = (): void => {


    if (currentValueTitle.value && !props.onlyCalc) return;

    selectOpen.value = !selectOpen.value;
};
const setData = (item: any): void => {
    if ((props.areaFormat || props.priceFormat) && windowWidth.value < 991) arrowBonus.value = false
    currentValue.value = get(item, "id");
    if (get(props, "noClear") !== true) iconShow.value = false;

    if (get(props, "showCurrencyToggler") === true || get(props, "priceFormat") === true) {
        currentValueTitle.value = get(item, "currentTitle");
        emit("getData", currentValue.value);
    } else if (props.areaFormat) {
        currentValueTitle.value = [item.title, item.title2];
        emit("getData", currentValue.value);
    } else {
        currentValueTitle.value =
            props.forNumber === true ? item : get(item, "title");
        get(props, "forNumber") === true
            ? emit("getData", parseInt(currentValueTitle.value))
            : emit("getData", currentValue.value);
    }
    if (!props.onlyCalc) {
        if (props.noClear) {
            selectOpen.value = true
        } else {
            selectOpen.value = false
        }
    } else {
        selectOpen.value = false
    }
};
const clearData = (): void => {
    if (props.forNumber) {
        iconShow.value = true
    } else {
        iconShow.value = true;
    }
    if ((props.areaFormat || props.priceFormat) && windowWidth.value < 991) {
        iconShow.value = false
        arrowBonus.value = true
    }
    currentValue.value = null;
    currentValueTitle.value = null;
    emit("getData", currentValue.value);
};

// WATCH
watch(
    props,
    (ns) => {
        if (ns.clearVal) {
            clearData();
        }
    },
    {
        immediate: true,
        deep: true,
    }
);
// watch(getAutoPriceVal, (ns) => {
//     if (ns !== null) {
//         currentValueTitle.value = ns
//     }
// })
watch(getCurrency, (ns) => {
    if (!props.onlyPrice && windowWidth.value > 991) return;
    if (currentValueTitle.value === null || !props.priceFormat && !props.onlyPrice) return;

    const divided = (Number(apStore.filteredData.selectedPrice[0]) / Number(get(store, "indx.usd.usd")))?.toFixed(0)


    currentValueTitle.value = `
        ${
            ns === '$'
                ? formatMoney(divided as any)
                : formatMoney((Number(apStore.filteredData.selectedPrice[0]))?.toFixed(0) as any)
        }
        - 
        ${
            ns === '$'
                ? formatMoney((Number(apStore.filteredData.selectedPrice[1]) / get(store, "indx.usd.usd"))?.toFixed(0) as any)
                : formatMoney((Number(apStore.filteredData.selectedPrice[1]))?.toFixed(0) as any)
        }
        `;
})

onMounted(() => {
    if (props?.autoSelectData !== null) {
        if (props?.areaFormat) {
            // @ts-ignore
            if (!props.autoSelectData[0]) return;
            const arr = props.data?.find(
                (el: { title: string }) =>
                    Number(get(el, "title")) ===
                    Number(get(props, "autoSelectData.0"))
            );
            currentValue.value = arr?.id;
            currentValueTitle.value = [arr?.title, arr?.title2];
            return;
        } else if (props?.priceFormat) {
            //@ts-ignore
            if (!props.autoSelectData[0]) return;
            const arr = props.data?.find(
                (el: { title: string }) =>
                    Number(get(el, "title")) ===
                    Number(get(props, "autoSelectData.0"))
            );
            currentValue.value = arr?.id;
            currentValueTitle.value = formatMoney(arr?.title) + ' ' + '-' + ' ' + formatMoney(arr?.title2);
            if (getCurrency.value === '$') {
                currentValueTitle.value = `${formatMoney((Number(apStore.filteredData.selectedPrice[0]) / get(store, "indx.usd.usd"))?.toFixed(0))} - ${formatMoney((Number(apStore.filteredData.selectedPrice[1]) / get(store, "indx.usd.usd"))?.toFixed(0))}`
            }
            return;
        }

        if (props.data[0]?.title) {
            currentValueTitle.value = props.data?.find(
                (el: { id: number }) => el?.id === Number(props?.autoSelectData)
            )?.title;
        } else {
            currentValueTitle.value = String(props?.autoSelectData);
        }
    }


    if (!props?.noClear) return;


    currentValueTitle.value = get(props, "data.0.title");
});

return (_ctx: any,_cache: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["select-dropdown", { 'toggler-layout': __props.showCurrencyToggler, 'layout2': __props.layout2, 'open': selectOpen.value }])
  }, [
    (__props.showCurrencyToggler)
      ? (_openBlock(), _createBlock(Switcher, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "top-cont rel br-13 flex j-btw al-center pointer",
      onClick: openSelect
    }, [
      (__props.areaFormat)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (currentValue.value !== null)
              ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
                  _createTextVNode(_toDisplayString(_ctx.$get(currentValueTitle.value, "0")) + " " + _toDisplayString(_unref(fn).tr("m")), 1),
                  _hoisted_3,
                  _createTextVNode(" - " + _toDisplayString(_ctx.$get(currentValueTitle.value, "1")) + " " + _toDisplayString(_unref(fn).tr("m")), 1),
                  _hoisted_4
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(__props.selectTitle || _ctx.$fn.tr("All")), 1))
          ]))
        : (__props.isSymbol)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(currentValue.value !== null || __props.noClear
                            ? `${currentValueTitle.value} ${_ctx.$fn.tr(__props.isSymbol)}`
                            : __props.selectTitle || _ctx.$fn.tr("All")), 1))
          : (__props.priceFormat)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(currentValueTitle.value || _ctx.$fn.tr("All")), 1))
            : (__props.roomFormat && currentValueTitle.value == _unref(apStore).filteredData.roomCount)
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(currentValue.value !== null || __props.noClear || __props.autoSelectData !== null && __props.roomFormat
                            ? `${currentValueTitle.value}+`
                            : __props.selectTitle || _ctx.$fn.tr("All")), 1))
              : (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(currentValue.value !== null || __props.noClear || __props.autoSelectData !== null
                            ? `${currentValueTitle.value}`
                            : __props.selectTitle || _ctx.$fn.tr("All")), 1))
    ]),
    (currentValue.value !== null && !__props.noClear)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "clear j-center al-center flex abs pointer",
          onClick: clearData
        }, [
          _createVNode(CloseLogo)
        ]))
      : _createCommentVNode("", true),
    ((__props.autoSelectData !== null || !isNaN(_ctx.$get(__props.autoSelectData, '0'))) && iconShow.value && _unref(windowWidth) < 991)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "clear j-center al-center flex abs pointer",
          onClick: clearData
        }, [
          _createVNode(CloseLogo)
        ]))
      : _createCommentVNode("", true),
    (arrowBonus.value && _unref(windowWidth) < 991)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(arrowDown)
        ]))
      : _createCommentVNode("", true),
    (iconShow.value && (__props.autoSelectData === null && isNaN(_ctx.$get(__props.autoSelectData, '0'))) && _unref(windowWidth) < 991)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createVNode(arrowDown)
        ]))
      : _createCommentVNode("", true),
    (__props.autoSelectData !== null && iconShow.value && _unref(windowWidth) > 991)
      ? (_openBlock(), _createElementBlock("div", {
          key: 5,
          class: "clear j-center al-center flex abs pointer",
          onClick: clearData
        }, [
          _createVNode(CloseLogo)
        ]))
      : _createCommentVNode("", true),
    (iconShow.value && __props.autoSelectData === null && _unref(windowWidth) > 991)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createVNode(arrowDown)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("section", {
      onMouseover: _cache[0] || (_cache[0] = ($event: any) => (_unref(store).disableScrollStatus = true)),
      onMouseout: _cache[1] || (_cache[1] = ($event: any) => (_unref(store).disableScrollStatus = false))
    }, [
      _createElementVNode("div", _hoisted_13, [
        (__props.areaFormat)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(filteredData), (item, index) => {
              return (_openBlock(), _createElementBlock("p", {
                class: "wc-lg anek light pointer",
                key: index,
                onClick: ($event: any) => (setData(item))
              }, [
                _createTextVNode(_toDisplayString(item.title) + " " + _toDisplayString(_unref(fn).tr("m")), 1),
                _hoisted_15,
                _createTextVNode(" - " + _toDisplayString(item.title2) + " " + _toDisplayString(_unref(fn).tr("m")), 1),
                _hoisted_16
              ], 8, _hoisted_14))
            }), 128))
          : (__props.showCurrencyToggler || __props.priceFormat)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(filteredData), (item, indx) => {
                return (_openBlock(), _createElementBlock("p", {
                  class: "wc-lg anek light pointer",
                  key: indx,
                  onClick: ($event: any) => (setData(item))
                }, _toDisplayString(_ctx.$get(item, "currentTitle")), 9, _hoisted_17))
              }), 128))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_unref(filteredData), (item, i) => {
                return (_openBlock(), _createElementBlock("p", {
                  class: "wc-lg anek light pointer",
                  key: i,
                  onClick: ($event: any) => (setData(item))
                }, _toDisplayString(__props.forNumber ? item : _ctx.$get(item, "title")), 9, _hoisted_18))
              }), 128))
      ])
    ], 32)
  ], 2)), [
    [_directive_click_outside, () => selectOpen.value = false]
  ])
}
}

})